import styled, { css } from 'styled-components';
import { withQuery, select } from '@panel/commons/core/themev2';
import { site } from '@panel/commons/helpers';
import radioButtom from '@panel/commons/assets/icons/radio_button.svg';
import radioButtomChecked from '@panel/commons/assets/icons/radio_button_checked.svg';
import AlertCircleBlue from '@panel/commons/assets/icons/AlertCircleBlue.svg';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  padding: 40px 40px 15px 45px;
  ${withQuery.xs.down()} {
    padding: 30px 16px 45px;
  }
`;

const ContainerMap = styled.div`
  ${withQuery.lg.up()} {
    padding: 0px 40px 45px;
  }
  ${withQuery.lg.down()} {
    padding-bottom: 46px;
  }
`;

const Title = styled.h2`
  font-size: 20px;
  margin-bottom: 30px;
  white-space: normal;
  ${withQuery.sm.down()} {
    font-size: 18px;
  }
`;

const TitleWrapper = styled.div`
  ${withQuery.lg.down()} {
    padding: 0 16px;
  }
`;
const Subtitle = styled.p`
  margin: 5px 0;
  color: ${select('darkGray')};
  white-space: normal;
`;

const MapNotice = styled.div`
  font-weight: 600;
  ${withQuery.lg.down()} {
    padding: 0 16px;
  }
`;

const InputCommonStyles = css`
  font-size: 1.4rem;
  height: 48px;
  padding: 0px 12px;
  border-radius: 8px;
  outline: none;
  font-family: 'Hind';
  &:focus {
    border-color: ${getColor('primary')};
  }
`;

const InputTitle = styled.p`
  margin: 5px 0;
`;

const Address = styled.input`
  ${InputCommonStyles}
  max-width: 608px;
  width: 100%;
  border: solid 1px ${select('midDarkGray')};
  :disabled {
    background-color: ${select('lightGray')};
    border: none;
    color: ${select('midLightGray')};
    ::placeholder {
      color: ${select('midLightGray')};
    }
  }
`;

const InputCEP = styled.input`
  ${InputCommonStyles}
  max-width: 608px;
  width: 100%;
  border: solid 1px ${select('midDarkGray')};
  -moz-appearance: textfield;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const SearchButton = styled.button`
  width: 105px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid ${getColor('primary')};
  cursor: pointer;
  margin-left: 8px;
  color: ${select('black')};
  :hover {
    color: ${getColor('primary')};
    svg path {
      fill: ${getColor('primary')};
    }
  }
  :disabled {
    background: ${select('lightGray')};
    border: 1px solid ${select('lightGray')};
  }
  svg {
    margin-left: 4px;
  }
  ${withQuery.xs.down()} {
    width: 100%;
    margin-left: 0px;
    margin-top: 8px;
  }
`;

const CepContainer = styled.div`
  ${withQuery.xs.down()} {
    display: flex;
    flex-direction: column;
  }
`;

const PlacesSuggestions = styled.div`
  padding: 8px 0;
  width: 608px;
  border-radius: 8px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px ${select('middleGray')};
  background-color: ${select('white')};
  font-size: 1.4rem;
  position: absolute;
  z-index: 1;
  .suggestion-item {
    opacity: 0.8;
    line-height: 32px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    &.active {
      background: ${select('lightGray')};
    }
  }
  ${withQuery.lg.down()} {
    width: 500px;
  }
  ${withQuery.sm.down()} {
    width: 82%;
  }
  ${withQuery.xs.down()} {
    width: 90%;
  }
`;

const AddressContainer = styled.div`
  width: 100%;
  margin-right: ${site.isBrasil ? '30px' : '0'};
`;

const ComplementContainer = styled.div`
  width: 100%;
`;

const InputComplement = styled.input`
  ${InputCommonStyles}
  max-width: 608px;
  width: 290px;
  border: solid 1px ${select('midDarkGray')};
  -moz-appearance: textfield;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${withQuery.lg.down()} {
    width: 100%;
  }
`;

const AddressFieldsContainer = styled.div`
  display: flex;
  max-width: 608px;
  margin: 10px 0;
  ${withQuery.lg.down()} {
    flex-direction: column;
  }
`;

const LocationCombosContainer = styled.div`
  display: flex;
  max-width: 608px;
  margin: 10px 0;
  ${withQuery.lg.down()} {
    flex-wrap: wrap;
  }
  ${withQuery.lg.up()} {
    div {
      &:first-child {
        margin-right: 30px;
      }
    }
  }
`;

const LocationSelectCombo = styled.select`
  ${InputCommonStyles}
  border: solid 1px ${select('midDarkGray')};
  width: 100%;
  background-color: ${select('white')};
  -webkit-appearance: none;
  -moz-appearance: none;
  &:hover {
    border-color: ${getColor('primary')};
    cursor: pointer;
  }
  &:disabled {
    background: ${select('lightGray')};
    color: ${select('midLightGray')};
    border: 0 none;
    cursor:default;
  }
`;

const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  top: -32px;
  right: 16px;
  float: right;
  pointer-events: none;
`;

const SingleCombo = styled.div`
  flex-direction: column;
  width: 300px;
  position: relative;
  ${withQuery.lg.down()} {
    width: 100%;
  }
`;

const ErrorMessage = styled.span`
  color: ${select('negative')};
  display: inherit;
  padding: 7px 0px 0px 12px;
  font-size: 12px;
`;

const MapAddress = styled.div`
  display: flex;
  align-items: center;
  color: ${select('darkGray')};
  white-space: normal;
  > span:first-child {
    color: ${select('darkGray')};
  }
  svg {
    vertical-align: bottom;
    margin-right: 8px;
  }
  ${withQuery.lg.down()} {
    padding: 0 16px;
  }
`;
const MapWrapper = styled.div`
  width: 100%;
  height: 440px;
  margin-bottom: 20px;
  background: #eaeaea;
  display: flex;
  justify-content: center;
  align-items: center;
  ${withQuery.lg.down()} {
    overflow: hidden;
    height: 320px;
  }
  .gm-style .gm-style-iw-c {
    border-radius: 20px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.09);
    border: 1px solid #7c98a7;
    padding: 8px 20px !important;
    > button {
      display: none !important;
    }
  }
  .gm-style-iw-tc::after {
    display: none;
  }
  .gm-style-iw-d {
    overflow: unset !important;
    padding: 0 !important;
  }
`;

const InfoWindowText = styled.p`
  font-weight: 500;
  font-size: 11px;
  font-family: Hind;
  ${withQuery.xs.down()} {
    font-size: 9px;
  }
`;

const CheckboxContainer = styled.div`
  width: fit-content;
  height: 22px;
  margin-bottom: 16px;
  > label {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    > img {
      margin-right: 8px;
      margin-bottom: 2px;
    }
  }
  ${withQuery.lg.down()} {
    padding: 0 16px;
  }
`;

const VisibilityOptionsAddressWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  ${withQuery.lg.down()} {
    flex-direction: column;
  }
`;

const VisibilityOptionsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  position: relative;
  & div.exact {
    margin-right: 18px;
  }
  ${withQuery.lg.down()} {
    justify-content: flex-start;
    padding: 0 16px;
    margin-bottom: 12px;
  }
`;

const VisibilityOptions = styled.div`
  height: auto;
  margin: 0px;
  position: relative;
  input {
    display: none;
  }
  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    > span {
      display: inline-block;
      padding: 2px 7px;
    }
  }
  label::before {
    display: inline-block;
  }
  input + label::before {
    content: '';
    width: 16px;
    height: 16px;
    background-image: url(${radioButtom});
  }
  input:checked + label::before {
    content: '';
    background-image: url(${radioButtomChecked});
  }
`;

const InfoBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px;
  border: 1px solid ${select('midLightGray')};
  border-left: 4px solid ${select('blue')};
  border-radius: 4px;
  white-space: normal;
  &:before {
    content: '';
    vertical-align: text-top;
    width: 16px;
    height: 16px;
    margin-right: 9px;
    position: absolute;
    background-image: url(${AlertCircleBlue});
    background-repeat: no-repeat;
    ${withQuery.xs.down()} {
      align-items: baseline;
      top: 16px;
    }
  }
  p {
    margin-left: 10px;
  }
  ${withQuery.xs.down()} {
    margin-bottom: 24px;
  }
  ${withQuery.lg.down()} {
    margin: 0 16px;
    width: auto;
  }
`;

export {
  Container,
  ContainerMap,
  Title,
  Subtitle,
  InputTitle,
  Address,
  PlacesSuggestions,
  AddressContainer,
  InputComplement,
  AddressFieldsContainer,
  ComplementContainer,
  LocationCombosContainer,
  LocationSelectCombo,
  IconWrapper,
  SingleCombo,
  ErrorMessage,
  MapAddress,
  MapWrapper,
  InfoWindowText,
  CheckboxContainer,
  VisibilityOptionsAddressWrapper,
  VisibilityOptionsContainer,
  VisibilityOptions,
  InfoBox,
  TitleWrapper,
  InputCEP,
  SearchButton,
  CepContainer,
  MapNotice
};
